<template>
  <div>
    <div v-if="Number(firstActiveIndex) % 5 === 0">
      <svg
        v-if="secondActiveIndex !== String(index) && index % 5 === 0"
        class="icon-middle"
        aria-hidden="true"
      >
        <use xlink:href="#iconjianzhuanquan" />
      </svg>
      <svg
        v-if="secondActiveIndex === String(index) && index % 5 === 0"
        class="icon-middle"
        aria-hidden="true"
      >
        <use xlink:href="#iconjianzhuanquan-active-copy" />
      </svg>
      <svg
        v-if="secondActiveIndex !== String(index) && index % 5 === 1"
        class="icon-middle"
        aria-hidden="true"
      >
        <use xlink:href="#iconzizhi" />
      </svg>
      <svg
        v-if="secondActiveIndex === String(index) && index % 5 === 1"
        class="icon-middle"
        aria-hidden="true"
      >
        <use xlink:href="#iconzizhi-active-copy" />
      </svg>
      <svg
        v-if="secondActiveIndex !== String(index) && index % 5 === 2"
        class="icon-middle"
        aria-hidden="true"
      >
        <use xlink:href="#iconshejishijianzhushi" />
      </svg>
      <svg
        v-if="secondActiveIndex === String(index) && index % 5 === 2"
        class="icon-middle"
        aria-hidden="true"
      >
        <use xlink:href="#iconshejishijianzhushi-active" />
      </svg>
      <svg
        v-if="secondActiveIndex !== String(index) && index % 5 === 3"
        class="icon-middle"
        aria-hidden="true"
      >
        <use xlink:href="#icondesigninpu" />
      </svg>
      <svg
        v-if="secondActiveIndex === String(index) && index % 5 === 3"
        class="icon-middle"
        aria-hidden="true"
      >
        <use xlink:href="#icondesigninpu-active-copy" />
      </svg>
      <svg
        v-if="secondActiveIndex !== String(index) && index % 5 === 4"
        class="icon-middle"
        aria-hidden="true"
      >
        <use xlink:href="#iconjianzhu" />
      </svg>
      <svg
        v-if="secondActiveIndex === String(index) && index % 5 === 4"
        class="icon-middle"
        aria-hidden="true"
      >
        <use xlink:href="#iconjianzhu-active-copy" />
      </svg>
      <svg
        v-if="secondActiveIndex !== String(index) && index % 5 === 5"
        class="icon-middle"
        aria-hidden="true"
      >
        <use xlink:href="#iconjiaoxuechengguo" />
      </svg>
      <svg
        v-if="secondActiveIndex === String(index) && index % 5 === 5"
        class="icon-middle"
        aria-hidden="true"
      >
        <use xlink:href="#iconjiaoxuechengguo-active-copy" />
      </svg>
      <div class="font-menu">{{item.name}}</div>
    </div>
    <div v-if="Number(firstActiveIndex) % 5 === 1">
      <svg
        v-if="secondActiveIndex !== String(index) && index % 5 === 0"
        class="icon-middle"
        aria-hidden="true"
      >
        <use xlink:href="#icondongtai" />
      </svg>
      <svg
        v-if="secondActiveIndex === String(index) && index % 5 === 0"
        class="icon-middle"
        aria-hidden="true"
      >
        <use xlink:href="#icondongtai-active-copy" />
      </svg>
      <svg
        v-if="secondActiveIndex !== String(index) && index % 5 === 1"
        class="icon-middle"
        aria-hidden="true"
      >
        <use xlink:href="#iconyanfa" />
      </svg>
      <svg
        v-if="secondActiveIndex === String(index) && index % 5 === 1"
        class="icon-middle"
        aria-hidden="true"
      >
        <use xlink:href="#iconyanfa-active-copy" />
      </svg>
      <svg
        v-if="secondActiveIndex !== String(index) && index % 5 === 2"
        class="icon-middle"
        aria-hidden="true"
      >
        <use xlink:href="#iconquanbuxinwen" />
      </svg>
      <svg
        v-if="secondActiveIndex === String(index) && index % 5 === 2"
        class="icon-middle"
        aria-hidden="true"
      >
        <use xlink:href="#iconquanbuxinwen-active-copy" />
      </svg>
      <svg
        v-if="secondActiveIndex !== String(index) && index % 5 === 3"
        class="icon-middle"
        aria-hidden="true"
      >
        <use xlink:href="#iconjingwuicon_svg_huaban" />
      </svg>
      <svg
        v-if="secondActiveIndex === String(index) && index % 5 === 3"
        class="icon-middle"
        aria-hidden="true"
      >
        <use xlink:href="#iconjingwuicon_svg_huaban-active-copy" />
      </svg>
      <svg
        v-if="secondActiveIndex !== String(index) && index % 5 === 4"
        class="icon-middle"
        aria-hidden="true"
      >
        <use xlink:href="#icongongzuotai" />
      </svg>
      <svg
        v-if="secondActiveIndex === String(index) && index % 5 === 4"
        class="icon-middle"
        aria-hidden="true"
      >
        <use xlink:href="#icongongzuotai-active-copy" />
      </svg>
      <svg
        v-if="secondActiveIndex !== String(index) && index % 5 === 5"
        class="icon-middle"
        aria-hidden="true"
      >
        <use xlink:href="#iconpingtaiyingyong" />
      </svg>
      <svg
        v-if="secondActiveIndex === String(index) && index % 5 === 5"
        class="icon-middle"
        aria-hidden="true"
      >
        <use xlink:href="#iconpingtaiyingyong-active-copy" />
      </svg>
      <div class="font-menu">{{item.name}}</div>
    </div>
    <div v-if="Number(firstActiveIndex) % 5 === 2">
      <svg
        v-if="secondActiveIndex !== String(index) && index % 5 === 0"
        class="icon-middle"
        aria-hidden="true"
      >
        <use xlink:href="#iconxinwengonggao" />
      </svg>
      <svg
        v-if="secondActiveIndex === String(index) && index % 5 === 0"
        class="icon-middle"
        aria-hidden="true"
      >
        <use xlink:href="#iconxinwengonggao-active-copy" />
      </svg>
      <svg
        v-if="secondActiveIndex !== String(index) && index % 5 === 1"
        class="icon-middle"
        aria-hidden="true"
      >
        <use xlink:href="#icongongzuotai1" />
      </svg>
      <svg
        v-if="secondActiveIndex === String(index) && index % 5 === 1"
        class="icon-middle"
        aria-hidden="true"
      >
        <use xlink:href="#icongongzuotai1-active-copy" />
      </svg>
      <svg
        v-if="secondActiveIndex !== String(index) && index % 5 === 2"
        class="icon-middle"
        aria-hidden="true"
      >
        <use xlink:href="#iconqiyelinian" />
      </svg>
      <svg
        v-if="secondActiveIndex === String(index) && index % 5 === 2"
        class="icon-middle"
        aria-hidden="true"
      >
        <use xlink:href="#iconqiyelinian-active-copy" />
      </svg>
      <svg
        v-if="secondActiveIndex !== String(index) && index % 5 === 3"
        class="icon-middle"
        aria-hidden="true"
      >
        <use xlink:href="#icondesign-preparat" />
      </svg>
      <svg
        v-if="secondActiveIndex === String(index) && index % 5 === 3"
        class="icon-middle"
        aria-hidden="true"
      >
        <use xlink:href="#icondesign-preparat-active-copy" />
      </svg>
      <svg
        v-if="secondActiveIndex !== String(index) && index % 5 === 4"
        class="icon-middle"
        aria-hidden="true"
      >
        <use xlink:href="#iconhuojiangdengji" />
      </svg>
      <svg
        v-if="secondActiveIndex === String(index) && index % 5 === 4"
        class="icon-middle"
        aria-hidden="true"
      >
        <use xlink:href="#iconhuojiangdengji-active-copy" />
      </svg>
      <svg
        v-if="secondActiveIndex !== String(index) && index % 5 === 5"
        class="icon-middle"
        aria-hidden="true"
      >
        <use xlink:href="#iconpingtaiyingyong" />
      </svg>
      <svg
        v-if="secondActiveIndex === String(index) && index % 5 === 5"
        class="icon-middle"
        aria-hidden="true"
      >
        <use xlink:href="#iconpingtaiyingyong-active-copy" />
      </svg>
      <div class="font-menu">{{item.name}}</div>
    </div>
    <div v-if="Number(firstActiveIndex) % 5 === 3">
      <svg
        v-if="secondActiveIndex !== String(index) && index % 5 === 0"
        class="icon-middle"
        aria-hidden="true"
      >
        <use xlink:href="#iconpingtaiguanli1" />
      </svg>
      <svg
        v-if="secondActiveIndex === String(index) && index % 5 === 0"
        class="icon-middle"
        aria-hidden="true"
      >
        <use xlink:href="#iconpingtaiguanli1-active-copy" />
      </svg>
      <svg
        v-if="secondActiveIndex !== String(index) && index % 5 === 1"
        class="icon-middle"
        aria-hidden="true"
      >
        <use xlink:href="#iconliucheng" />
      </svg>
      <svg
        v-if="secondActiveIndex === String(index) && index % 5 === 1"
        class="icon-middle"
        aria-hidden="true"
      >
        <use xlink:href="#iconliucheng-active-copy" />
      </svg>
      <svg
        v-if="secondActiveIndex !== String(index) && index % 5 === 2"
        class="icon-middle"
        aria-hidden="true"
      >
        <use xlink:href="#iconhuizhengongzuoliang" />
      </svg>
      <svg
        v-if="secondActiveIndex === String(index) && index % 5 === 2"
        class="icon-middle"
        aria-hidden="true"
      >
        <use xlink:href="#iconhuizhengongzuoliang-active-copy" />
      </svg>
      <svg
        v-if="secondActiveIndex !== String(index) && index % 5 === 3"
        class="icon-middle"
        aria-hidden="true"
      >
        <use xlink:href="#iconhuanjing" />
      </svg>
      <svg
        v-if="secondActiveIndex === String(index) && index % 5 === 3"
        class="icon-middle"
        aria-hidden="true"
      >
        <use xlink:href="#iconhuanjing-active-copy" />
      </svg>
      <svg
        v-if="secondActiveIndex !== String(index) && index % 5 === 4"
        class="icon-middle"
        aria-hidden="true"
      >
        <use xlink:href="#iconliuchengguanli" />
      </svg>
      <svg
        v-if="secondActiveIndex === String(index) && index % 5 === 4"
        class="icon-middle"
        aria-hidden="true"
      >
        <use xlink:href="#iconliuchengguanli-active-copy" />
      </svg>
      <svg
        v-if="secondActiveIndex !== String(index) && index % 5 === 5"
        class="icon-middle"
        aria-hidden="true"
      >
        <use xlink:href="#iconchengguozhuanhua" />
      </svg>
      <svg
        v-if="secondActiveIndex === String(index) && index % 5 === 5"
        class="icon-middle"
        aria-hidden="true"
      >
        <use xlink:href="#iconchengguozhuanhua-active-copy" />
      </svg>
      <div class="font-menu">{{item.name}}</div>
    </div>
    <div v-if="Number(firstActiveIndex) % 5 === 4">
      <svg
        v-if="secondActiveIndex !== String(index) && index % 5 === 0"
        class="icon-middle"
        aria-hidden="true"
      >
        <use xlink:href="#icondxal" />
      </svg>
      <svg
        v-if="secondActiveIndex === String(index) && index % 5 === 0"
        class="icon-middle"
        aria-hidden="true"
      >
        <use xlink:href="#icondxal-active-copy" />
      </svg>
      <svg
        v-if="secondActiveIndex !== String(index) && index % 5 === 1"
        class="icon-middle"
        aria-hidden="true"
      >
        <use xlink:href="#iconyanfa" />
      </svg>
      <svg
        v-if="secondActiveIndex === String(index) && index % 5 === 1"
        class="icon-middle"
        aria-hidden="true"
      >
        <use xlink:href="#iconyanfa-active-copy" />
      </svg>
      <svg
        v-if="secondActiveIndex !== String(index) && index % 5 === 2"
        class="icon-middle"
        aria-hidden="true"
      >
        <use xlink:href="#iconyanfa1" />
      </svg>
      <svg
        v-if="secondActiveIndex === String(index) && index % 5 === 2"
        class="icon-middle"
        aria-hidden="true"
      >
        <use xlink:href="#iconyanfa1-active-copy" />
      </svg>
      <svg
        v-if="secondActiveIndex !== String(index) && index % 5 === 3"
        class="icon-middle"
        aria-hidden="true"
      >
        <use xlink:href="#iconchengguo" />
      </svg>
      <svg
        v-if="secondActiveIndex === String(index) && index % 5 === 3"
        class="icon-middle"
        aria-hidden="true"
      >
        <use xlink:href="#iconchengguo-active-copy" />
      </svg>
      <svg
        v-if="secondActiveIndex !== String(index) && index % 5 === 4"
        class="icon-middle"
        aria-hidden="true"
      >
        <use xlink:href="#icon42-jujiao" />
      </svg>
      <svg
        v-if="secondActiveIndex === String(index) && index % 5 === 4"
        class="icon-middle"
        aria-hidden="true"
      >
        <use xlink:href="#icon42-jujiao-active-copy" />
      </svg>
      <svg
        v-if="secondActiveIndex !== String(index) && index % 5 === 5"
        class="icon-middle"
        aria-hidden="true"
      >
        <use xlink:href="#iconzizhi" />
      </svg>
      <svg
        v-if="secondActiveIndex === String(index) && index % 5 === 5"
        class="icon-middle"
        aria-hidden="true"
      >
        <use xlink:href="#iconzizhi-active-copy" />
      </svg>
      
      <div class="font-menu">{{item.name}}</div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { dotdot } from '../utils/common';
export default {
  name: 'iconMenu',
  data() {
    return {
      firstActiveIndex: this.$route.params.firstActiveIndex || '0',
      firstId: this.$route.params.firstId,
      secondActiveIndex: this.$route.params.secondActiveIndex || '0',
      secondId: this.$route.params.secondId,
    };
  },
  props: {
    index: Number,
    item: Object,
  },
  watch: {
    $route(to, from) {
      this.secondActiveIndex = this.$route.params.secondActiveIndex;
    }
  },
  computed: {
    ...mapGetters([
      'systemName',
      'menuListData',
      'baseImageUrl',
      'firstMenuMutation',
      'firstMenuMapMutation',
      'secondMenuMutation',
      'secondMenuMapMutation',
      'thirdMenuMutation',
      'thirdMenuMapMutation',
    ]),
  },
  methods: {
    ...mapActions([
      'menuIdContent'
    ]),
  }
};
</script>